import axios from 'axios'
import {apiDomain} from '../../config'

let axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
	    'token': localStorage.getItem('access_token')
	}
}

export default {
	getAll () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hazards/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						resolve(response.data)
					} else {
						resolve(response.data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/hazard/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update (HazardId , model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/hazard/update/' +  HazardId + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete (  HazardId ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/hazard/delete/' + HazardId  + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy ( HazardId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/hazard/' + HazardId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore ( HazardId  ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/hazard/restore/' + HazardId  + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAllC () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/controls/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						resolve(response.data)
					} else {
						resolve(response.data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	saveC ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/control/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateC (ControlId  , model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/control/update/' +  ControlId  + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deleteC (  ControlId  ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/control/delete/' + ControlId   + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getByC ( ControlId  ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/control/' + ControlId  + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restoreC ( ControlId  ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/control/restore/' + ControlId  + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAll_tdg () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/tdgs/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						resolve(response.data)
					} else {
						resolve(response.data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save_tdg ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/tdg/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy_tdg ( TdgId  ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/tdg/' + TdgId  + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update_tdg (TdgId  , model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/tdg/update/' +  TdgId  + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete_tdg (  TdgId  ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/tdg/delete/' + TdgId   + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore_tdg ( TdgId  ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/tdg/restore/' + TdgId  + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
}



// WEBPACK FOOTER //
// ./src/views/cnr/cnr_service.js